export enum Language {
    NL = 'nl',
    FR = 'fr',
    DE = 'de',
}
